import { render, staticRenderFns } from "./bianyaqi.vue?vue&type=template&id=1829cc6c&scoped=true&"
import script from "./bianyaqi.vue?vue&type=script&lang=js&"
export * from "./bianyaqi.vue?vue&type=script&lang=js&"
import style0 from "./bianyaqi.vue?vue&type=style&index=0&id=1829cc6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829cc6c",
  null
  
)

export default component.exports